import AuthService from "../../service/AuthService";


export const state = {
  token: null,
  isDocumentsUpt: false,
  authLoading: false,
  screen: "login",
  username: "",
  customerid: "",
  name: "",
  roles:"",
  email: "",
  auth: {
    'username' : '',
    'customerid': ''
  },
  regScreen: "reg",
  response: {
    roles: ''
  }
};

export const getters = {
  getTok: state => {
    // console.log("getter getTok")
    return state.token;
  },

  getauth: state =>{
    return state.auth;
  },

  getUserTokenFromLocalStorage() {
    if (state.token == null){
      console.log(`Bearer ${localStorage.getItem("token")}`);
      return `Bearer ${localStorage.getItem("token")}`;
    }else{
      console.log(state.token);
      return state.token
    }

  },

};

export const mutations = {
  UPDATE_RESPONSE: (state, payload) => {
    state.response = payload;
  },

  LOAD_PROFILE: (state, payload) => {
    state.username =  payload.username;
    state.customerid = payload.customerid;
    state.name =  payload.name;
    state.roles = payload.roles;
    state.email = payload.email
  },

  updateAuthLoading: (state, payload) => {
    state.authLoading = payload;
  },

  updateScreen: (state, payload) => {
    state.screen = payload;
  },

  UPDATE_TOKEN: (state, payload) => {
    state.token = payload;
  },

  updateRegScreen: (state, payload) => {
    state.regScreen = payload;
  },

  updateAuthToken: (state, payload) => {
    // console.log("mutation updateAuthToken ==>>", payload)
    state.q_auth = payload;
  },

  reset: (state, payload) => {
    console.log(payload);
    state.q_auth = null;
    state.isDocumentsUpt = false;
    state.authLoading = false;
    state.screen = "login";
    state.regScreen = "reg";
    state.response = {};
    localStorage.clear();

  }
};

export const actions = {
  logon: ({ commit }, payload) => {
    commit("updateAuthLoading", true);
    commit("UPDATE_RESPONSE", {});
    return AuthService.callLogonApi(payload)
      .then(response => {
        commit("updateAuthLoading", false);
        let responseData = response.data;
        if (responseData.responsecode === "00"){
          commit("LOAD_PROFILE", responseData);
          commit("UPDATE_TOKEN", 'Bearer '+responseData.jwt);
        }
        return responseData
      })
      .catch(error => {
        commit("updateAuthLoading", false);
        console.log(error);
        // throw error;
        return error.response
      });
  },


  resetPassword: ({ commit }, payload) => {
    commit("updateAuthLoading", true);
    return AuthService.resetPassword(payload)
        .then(response => {
          commit("updateAuthLoading", false);
          console.log(response.data)
          return response.data;
        })
        .catch(error => {
          console.log(error);
          commit("updateAuthLoading", false);
        })
  },

  forgotPassword: ({ commit }, payload) => {
    commit("updateAuthLoading", true);
    return AuthService.forgotPassword(payload)
        .then(response => {
          commit("updateAuthLoading", false);
          let responseData = response.data;
          return responseData;
        })
        .catch(error => {
          console.log(error);
          commit("updateAuthLoading", false);
        })
  },


  userdetails: ({ commit }, payload) => {
    return AuthService.callUserDetails(payload)
        .then(response => {
          const responseData = response.data;
          commit("LOAD_PROFILE", responseData);
          commit("UPDATE_RESPONSE", responseData);
          return responseData
        })
        .catch(error => {
          console.log(error.data)
        })
  },

  reset: ({ commit }, payload) => {
    commit("reset", payload);
  }
};
